import { Pipe, PipeTransform } from '@angular/core';

interface IBloqueado{
  number: string;
}


@Pipe({
  name: 'filterBloqueado',
  standalone: true
})
export class BloqueadoPipe implements PipeTransform {

  transform(arrayBloqueados: Array<IBloqueado>, valueFilter: string): any {
    if(arrayBloqueados.length === 0 || !valueFilter){ 
      return arrayBloqueados;
    }else {
      const newArray: Array<IBloqueado> = arrayBloqueados.filter(element => element.number.toLowerCase().includes(valueFilter.toLowerCase()));
      return newArray;
    }
  }

}
